<template>
  <div v-if="shouldShow" class="infosec-modal-wrapper" @click.self="close">
    <div class="infosec-modal">
      <div class="infosec-modal__close" @click="close">
        <v-icon name="close"></v-icon>
      </div>

      <div class="infosec-modal__content">
        <div class="infosec-modal__icon">🚨</div>
        <div class="infosec-modal__title">Procura-se Dev com foco em Segurança da Informação ou Automação (N8N)</div>

        <div class="infosec-modal__text">
          <p>Se você:</p>
          <ul>
            <li>Atua com varredura e cultura de InfoSec 🔒</li>
            <li>OU cria automações com N8N 🤖</li>
          </ul>
          <p>Temos uma oportunidade específica para o seu perfil.</p>
        </div>

        <div class="infosec-modal__button">
          <v-button
            tag="a"
            href="https://wa.me/5571996992359"
            target="_blank"
            class="primary"
            @click="close"
          >
            👉 Falar com a Comunidade
          </v-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoSecOpportunityModal',
  data() {
    return {
      campaignId: 'INFOSEC_N8N_OPPORTUNITY_2025',
      shouldShow: false
    }
  },
  methods: {
    close() {
      this.shouldShow = false;
      // Salvar no localStorage que o modal foi fechado
      localStorage.setItem(this.campaignId, 'closed');
      this.$emit('onHide');
    },
    checkIfShouldShow() {
      // Verifica se o modal já foi fechado anteriormente
      const wasClosed = localStorage.getItem(this.campaignId);
      this.shouldShow = !wasClosed;
    }
  },
  mounted() {
    this.checkIfShouldShow();
  }
}
</script>

<style lang="scss" scoped>
.infosec-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.infosec-modal {
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.infosec-modal__close {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;

  &:hover {
    color: #333;
  }
}

.infosec-modal__content {
  padding: 40px 30px 30px;
  text-align: center;
}

.infosec-modal__icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.infosec-modal__title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.4;
}

.infosec-modal__text {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 25px;
  text-align: left;

  p {
    margin-bottom: 10px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 15px 0;

    li {
      padding: 8px 0;
      position: relative;
      padding-left: 10px;

      &:before {
        content: "•";
        position: absolute;
        left: 0;
        color: #007bff;
        font-weight: bold;
      }
    }
  }
}

.infosec-modal__button {
  margin-top: 20px;

  .primary {
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modals/infosec-opportunity-modal.vue